import * as THREE from 'three';

// Loads what tools/build-glowtide.mjs prepared for visualizers/glowtide.js -
// the night beach photograph, the masks (R sea, G foam, B wet sand) and the
// foam lines with the shore (Float32 rows) - ONCE, at startup. Same
// preload/get shape as startrails-assets.js, and the same rule: the preload is
// a WIRING POINT every entry point must call, and it resolves false when
// anything is missing so the entry point can withdraw Glowtide from the
// rotation (the brief's fallback: without the image or its masks, unavailable).
const MANIFEST_URL = 'textures/glowtide.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
// the masks are DATA (softened at the build): linear, no colour space
function data(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadGlowtide() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('glowtide.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.photo, photo),
        loadTexture('textures/' + manifest.masks, data),
        fetch('textures/' + manifest.linesBin).then(function (r) {
          if (!r.ok) throw new Error(manifest.linesBin + ' HTTP ' + r.status);
          return r.arrayBuffer();
        })
      ]).then(function (parts) {
        const lines = new Float32Array(parts[2]);
        if (lines.length !== (manifest.lines + 2) * manifest.size[0] * 2) throw new Error('glowtide lines: unexpected size');
        _assets = { manifest: manifest, photo: parts[0], masks: parts[1], lines: lines };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] glowtide assets unavailable, Glowtide is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getGlowtide() {
  return _assets;
}
